// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__sEcWb","modalForm":"UpgradeEpcsModal_modalForm__1wNEG","modalFooter":"UpgradeEpcsModal_modalFooter__2eJuO"};